// Video History action types
export const VideoHistoryTypes = {
  // Fetch video history
  FETCH_VIDEO_HISTORY_REQUEST: 'FETCH_VIDEO_HISTORY_REQUEST',
  FETCH_VIDEO_HISTORY_SUCCESS: 'FETCH_VIDEO_HISTORY_SUCCESS',
  FETCH_VIDEO_HISTORY_FAILURE: 'FETCH_VIDEO_HISTORY_FAILURE',
  
  // Add to video history
  ADD_TO_VIDEO_HISTORY_REQUEST: 'ADD_TO_VIDEO_HISTORY_REQUEST',
  ADD_TO_VIDEO_HISTORY_SUCCESS: 'ADD_TO_VIDEO_HISTORY_SUCCESS',
  ADD_TO_VIDEO_HISTORY_FAILURE: 'ADD_TO_VIDEO_HISTORY_FAILURE',
  
  // Update video progress
  UPDATE_VIDEO_PROGRESS_REQUEST: 'UPDATE_VIDEO_PROGRESS_REQUEST',
  UPDATE_VIDEO_PROGRESS_SUCCESS: 'UPDATE_VIDEO_PROGRESS_SUCCESS',
  UPDATE_VIDEO_PROGRESS_FAILURE: 'UPDATE_VIDEO_PROGRESS_FAILURE',
  
  // Mark video as completed
  MARK_VIDEO_COMPLETED_REQUEST: 'MARK_VIDEO_COMPLETED_REQUEST',
  MARK_VIDEO_COMPLETED_SUCCESS: 'MARK_VIDEO_COMPLETED_SUCCESS',
  MARK_VIDEO_COMPLETED_FAILURE: 'MARK_VIDEO_COMPLETED_FAILURE',
  
  // Playback control for history
  LOAD_HISTORY_FOR_PLAYBACK_REQUEST: 'LOAD_HISTORY_FOR_PLAYBACK_REQUEST',
  LOAD_HISTORY_FOR_PLAYBACK_SUCCESS: 'LOAD_HISTORY_FOR_PLAYBACK_SUCCESS',
  LOAD_HISTORY_FOR_PLAYBACK_FAILURE: 'LOAD_HISTORY_FOR_PLAYBACK_FAILURE',
  
  NEXT_HISTORY_VIDEO: 'NEXT_HISTORY_VIDEO',
  PREVIOUS_HISTORY_VIDEO: 'PREVIOUS_HISTORY_VIDEO',
  SET_HISTORY_PLAYBACK_INDEX: 'SET_HISTORY_PLAYBACK_INDEX',
  TOGGLE_HISTORY_AUTOPLAY: 'TOGGLE_HISTORY_AUTOPLAY',
  CLEAR_HISTORY_PLAYBACK: 'CLEAR_HISTORY_PLAYBACK',
  
  // UI Actions
  SHOW_TOAST: 'SHOW_TOAST',
  SET_VIEW_MODE: 'SET_VIEW_MODE'
};
